import { Component, OnInit } from '@angular/core';
import { StorageService } from './services/storage.service';
import { CocheSeguro } from './modelos/cocheSeguro.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { environment } from 'src/environments/environment';
import { StyleCocheSeguro } from './modelos/styleCocheseguro.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(private storageService: StorageService, private afs: AngularFirestore) {

    if (!this.storageService.ifExist("cocheSeguro")) {
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      cocheSeguro.dominioMkp = "https://lb3.copsis.com"; // Variable de entorno para dominio
      switch(window.location.hostname){
        case 'localhost':
        case 'inter-autos-qa.web.app':
        case 'inter-autos-covid-qa.web.app':
          cocheSeguro.dominioMkp = "https://skynet.copsis.com:8181"; // Variable de entorno para dominio    
          break;
        default: 
          cocheSeguro.dominioMkp = "https://lb3.copsis.com";
          break;
      }
      cocheSeguro.m = "zl8mIfg3UrGeD1CvQu7UddMRtZ9eljnfGDTy+oOne/8="; // Base 84 = Variable de entorno para marketplace session    .
      cocheSeguro.ntf = true; // Variable de entorno para no tiene firebase.
      cocheSeguro.a = "0+Y4Bb5ZQpzt/bhc0/MgmnsLFlwWRXJ/cZtnrevNBPUDOtY35HUd3/xHOCo7Tyi9gDC+r5eH8g5WRgVuns8mYw=="; // Variable de entorno para mi cuenta Marketplace.  
      this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
    }
    if (!this.storageService.ifExist("styleCocheSeguro")) {
      let styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
      switch (window.location.hostname) {

        case "localhost":
          styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/copsis/logo_copsis.png";
          styleCocheSeguro.srcBanner = "url(../../assets/images/nuevobanner2.jpg)";
          styleCocheSeguro.bgBanner = "#00142d";
          styleCocheSeguro.bgServicios = "#0e1751";
          styleCocheSeguro.bgPrimary = "#035AA6";
          styleCocheSeguro.bgSecondary = "#151515";
          styleCocheSeguro.bgTertiary = "";
          styleCocheSeguro.bgFooter = "#151515";
          styleCocheSeguro.textMark = "#F57C00";
          styleCocheSeguro.textMarkSecondary = "transparent";
          styleCocheSeguro.colorBtn = "copsis";
          styleCocheSeguro.colorPicker = "#151515";
          break;
       
        case "cochesegurouvm.inter.mx":
          styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/uvm/logo_uvm.png";
          styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/uvm/img_bg_uvm.png)";
          styleCocheSeguro.bgBanner = "#b8b8b8";
          styleCocheSeguro.bgServicios = "";
          styleCocheSeguro.bgPrimary = "#b8b8b8";
          styleCocheSeguro.bgSecondary = "#b22227";
          styleCocheSeguro.bgTertiary = "#ed6b70";
          styleCocheSeguro.bgFooter = "#b8b8b8";
          styleCocheSeguro.textMark = "#e72400";
          styleCocheSeguro.textMarkSecondary = "transparent";
          styleCocheSeguro.colorBtn = "uvm";
          styleCocheSeguro.colorPicker = "#b22227";
          break;
        case "cochesegurounitec.inter.mx":
          styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/unitec/logo_unitec.png";
          styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/unitec/bg_unitec.png)";
          styleCocheSeguro.bgBanner = "#006fba";
          styleCocheSeguro.bgServicios = "";
          styleCocheSeguro.bgPrimary = "#b8b8b8";
          styleCocheSeguro.bgSecondary = "#0f406b";
          styleCocheSeguro.bgTertiary = "#68b4f7";
          styleCocheSeguro.bgFooter = "#006fba";
          styleCocheSeguro.textMark = "#0f406b";
          styleCocheSeguro.textMarkSecondary = "transparent";
          styleCocheSeguro.colorBtn = "unitec";
          styleCocheSeguro.colorPicker = "#0f406b";
          break;
        case "cochesegurounifin.inter.mx": case "cochesegurounifinempleados.inter.mx":
          styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/unifin/logo_unifin.png";
          styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/unifin/img_bg_unifin.jpg)";
          styleCocheSeguro.bgBanner = "#00142d";
          styleCocheSeguro.bgServicios = "#0e1751";
          styleCocheSeguro.bgPrimary = "#0e1751";
          styleCocheSeguro.bgSecondary = "#009dd0";
          styleCocheSeguro.bgTertiary = "#88DFF9";
          styleCocheSeguro.bgFooter = "#009dd0";
          styleCocheSeguro.colorBtn = "inter";
          styleCocheSeguro.colorPicker = "#039ECC";
          styleCocheSeguro.textMark = "#0e1751";
          styleCocheSeguro.textMarkSecondary = '#00b8ff';
          break;
        case "cochesegurolottus.inter.mx":
          styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/lottus/logo_lottus.png";
          styleCocheSeguro.srcBanner = "url(./assets/images/checo-background-azul.png)";
          styleCocheSeguro.bgBanner = "#00142d";
          styleCocheSeguro.bgServicios = "";
          styleCocheSeguro.bgPrimary = "#b8b8b8";
          styleCocheSeguro.bgSecondary = "#0f406b";
          styleCocheSeguro.bgTertiary = "#68b4f7";
          styleCocheSeguro.bgFooter = "#006fba";
          styleCocheSeguro.textMark = "#0f406b";
          styleCocheSeguro.textMarkSecondary = "transparent";
          styleCocheSeguro.colorBtn = "unitec";
          styleCocheSeguro.colorPicker = "#0f406b";
          break;
        case "cochesegurostone.inter.mx":
          styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/stone/logo_stone.png";
          styleCocheSeguro.srcBanner = "url(./assets/images/checo-background-azul.png)";
          styleCocheSeguro.bgBanner = "#00142d";
          styleCocheSeguro.bgServicios = "";
          styleCocheSeguro.bgPrimary = "#b8b8b8";
          styleCocheSeguro.bgSecondary = "#0f406b";
          styleCocheSeguro.bgTertiary = "#68b4f7";
          styleCocheSeguro.bgFooter = "#006fba";
          styleCocheSeguro.textMark = "#0f406b";
          styleCocheSeguro.textMarkSecondary = "transparent";
          styleCocheSeguro.colorBtn = "unitec";
          styleCocheSeguro.colorPicker = "#0f406b";
          break;
     

          case "cocheseguroclubpremier.inter.mx":            
            styleCocheSeguro.srcBanner = "url(./assets/images/premier/fondoPremier.png)";
            styleCocheSeguro.bgBanner = "#00142d";
            styleCocheSeguro.bgServicios = "#0e1751";
            styleCocheSeguro.bgPrimary = "#0e1751";
            styleCocheSeguro.bgSecondary = "#009dd0";
            styleCocheSeguro.bgTertiary = "#88DFF9";
            styleCocheSeguro.bgFooter = "#009dd0";
            styleCocheSeguro.colorBtn = "inter";
            styleCocheSeguro.colorPicker = "#039ECC";
            styleCocheSeguro.textMark = "#0e1751";
            styleCocheSeguro.textMarkSecondary = '#00b8ff';
          break;

          case "cochesegurosivale.inter.mx":
          styleCocheSeguro.srcBanner = "url(./assets/images/premier/fondoPremier.png)";
          styleCocheSeguro.bgBanner = "#00142d";
          styleCocheSeguro.bgServicios = "#0e1751";
          styleCocheSeguro.bgPrimary = "#0e1751";
          styleCocheSeguro.bgSecondary = "#009dd0";
          styleCocheSeguro.bgTertiary = "#88DFF9";
          styleCocheSeguro.bgFooter = "#009dd0";
          styleCocheSeguro.colorBtn = "inter";
          styleCocheSeguro.colorPicker = "#039ECC";
          styleCocheSeguro.textMark = "#0e1751";
          styleCocheSeguro.textMarkSecondary = '#00b8ff';
        break;

        case "cocheseguromanpower.inter.mx":        
          styleCocheSeguro.srcBanner = "url(./assets/images/premier/fondoPremier.png)";
          styleCocheSeguro.bgBanner = "#00142d";
          styleCocheSeguro.bgServicios = "#0e1751";
          styleCocheSeguro.bgPrimary = "#0e1751";
          styleCocheSeguro.bgSecondary = "#009dd0";
          styleCocheSeguro.bgTertiary = "#88DFF9";
          styleCocheSeguro.bgFooter = "#009dd0";
          styleCocheSeguro.colorBtn = "inter";
          styleCocheSeguro.colorPicker = "#039ECC";
          styleCocheSeguro.textMark = "#0e1751";
          styleCocheSeguro.textMarkSecondary = '#00b8ff';
        break;

      }
      this.storageService.setItem("styleCocheSeguro", JSON.stringify(styleCocheSeguro));
    }
  }

  ngOnInit() {
    try {
      this.afs.firestore.app.auth().signInWithEmailAndPassword(environment.firebase.email, environment.firebase.pass).then(value => {
        //console.log('value', value);
      })
        .catch(error => {
          console.error('catalogos.appComponent.ngOnInit.afs.catch', error);
        });
    } catch (error) {
      console.error('catalogos.appComponent.ngOnInit.catch', error);
    }
  }
}
